import React, { Component } from 'react';
import Faqs from '../../containers/Faqs/Faqs';

class FaqsPage extends Component {
  render() {
    return <Faqs />;
  }
}

export default FaqsPage;
